import { lazy, Suspense } from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import messages from './messages'

// Code-splitting happens at the Page → Feature Set chunk (ReportsRouter
// convention — routers import pages directly).
const OverallSpendReportViewChunk = lazy(() =>
  import('../feature-sets/OverallSpendReportView').then(
    ({ OverallSpendReportView }) => ({
      default: OverallSpendReportView,
    })
  )
)

export const OverallSpendReportPageTabs = {
  DEPARTMENT: 'department',
  ACCOUNT_CODE: 'account-code',
} as const

export interface OverallSpendReportPageParams {
  type: string
}

export const OverallSpendReportPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.overallSpendReportPageTitle)}
      breadcrumbs={[
        { name: intl.formatMessage(messages.overallSpendReportPageTitle) },
      ]}
    >
      <div data-testid='overall-spend-report-page'>
        <Suspense fallback={null}>
          <OverallSpendReportViewChunk />
        </Suspense>
      </div>
    </Page>
  )
}
